import customCompsetPalette from '@/config/customCompsetPalette';

import getRandomBetween from '@/utils/getRandomBetween';

const getRandomCompsetColor = () => customCompsetPalette[
  getRandomBetween(0, customCompsetPalette.length - 1)
];

export default getRandomCompsetColor;
